import {Animated} from 'react-native';
import styled from 'styled-components/native';
import {
  BorderProps,
  ColorProps,
  FlexboxProps,
  HeightProps,
  LayoutProps,
  PositionProps,
  ShadowProps,
  SpaceProps,
  border,
  color,
  flexbox,
  height,
  layout,
  position,
  shadow,
  space,
} from 'styled-system';

export interface AnimatedViewProps
  extends BorderProps,
    ColorProps,
    FlexboxProps,
    HeightProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps {}

export const AnimatedView = styled(Animated.View)<AnimatedViewProps>`
  ${border};
  ${color};
  ${height};
  ${space};
  ${layout};
  ${flexbox};
  ${shadow};
  ${position};
`;
